import React from 'react';

import { ActionIcon, ColorSwatch, Group, Loader, Text, useMantineTheme } from '@mantine/core';
import { IconRotate } from '@tabler/icons-react';
import useStripeTerminalReaderStatus from 'hooks/stripeTerminalReader/useStripeTerminalReaderStatus';

interface StripeTerminalReaderStatusIndicatorProps {
  enabled: boolean;
}

const StripeTerminalReaderStatusIndicator = ({
  enabled,
}: StripeTerminalReaderStatusIndicatorProps): JSX.Element => {
  const theme = useMantineTheme();
  const { data, isError, isLoading, isSuccess, isFetching, refetch } = useStripeTerminalReaderStatus({
    enabled,
  });

  const isOnline = isSuccess && data?.data.isOnline;
  const isOffline = isError || (isSuccess && !data?.data.isOnline);

  return (
    <Group spacing='xs'>
      {isLoading && (
        <>
          <Loader size='sm' />
          <Text size='sm'>Connecting to reader...</Text>
        </>
      )}

      {(isError || isSuccess) && (
        <>
          <ColorSwatch
            color={isOnline ? theme.colors.green[6] : theme.colors.red[6]}
            size={theme.fontSizes.md}
          />

          {isOffline && (
            <ActionIcon
              variant='transparent'
              color='red'
              size='sm'
              loading={isFetching}
              onClick={() => refetch()}
            >
              <IconRotate size='1.2rem' />
            </ActionIcon>
          )}

          <Text size='sm' color={isOnline ? theme.colors.green[8] : theme.colors.red[8]}>
            {isOnline && 'Reader connected'}
            {isOffline && 'Reader connection failed'}
          </Text>
        </>
      )}
    </Group>
  );
};

export default StripeTerminalReaderStatusIndicator;
